import { GameEvent } from 'excalibur';
import { TRASH_TYPE } from '../enums';

export class CatchTrashEvent extends GameEvent<TRASH_TYPE> {
	constructor(public type: TRASH_TYPE) {
		super();
	}
}
